
import { createContext } from 'react';
import _graphql_client_init_state from './_graphql_client_init_state';

export const GraphQLClientContext = createContext(_graphql_client_init_state);
GraphQLClientContext.displayName = 'GraphQLClientContext';
